<template>
  <div>
    <v-card flat
      style="position: relative; overflow: auto; width: 100%; display: flex; flex-direction: column; justify-content: center; margin-bottom: 3px"
      class="noSelect px-2" :style="{
        height: heightPerSlot * (computedTravelTimePrev) - 3 + 'px',
        'background-color': backgroundColor,
        color: color,
        'border': border,
        'pointer-events': item.value.created ? 'none' : 'all',
      }" v-if="!duplicationMode && item.rendered && computedTravelTimePrev">
      <span v-if="!showRoomCalendar">
        <i v-if="isExternalLocation">{{ $t("basics.travelTimePrev") }}</i>
        <i v-else>{{ $t("basics.prepTimePrev") }}</i></span>
    </v-card>
    <v-card flat style="overflow: hidden; width: 100%; display: flex; flex-direction: column" class="noSelect" :style="{
      height: heightPerSlot * (item.duration - computedTravelTimePrev - computedTravelTimeAfter) - 3 + 'px',
      'background-color': backgroundColor,
      color: color,
      'border': border,
      'pointer-events': item.value.created ? 'none' : 'all',
    }" v-if="item.rendered">

      <v-tooltip v-if="item.value.description && !item.value.private" :text="item.value.description">
        <template v-slot:activator="{ props }">
          <div v-bind="props" style="
            position: absolute;
            right: 0;
            background-color: rgb(var(--v-theme-error));
            width: 14px;
            height: 14px;
            border-radius: 50%;
          "></div>
        </template>
      </v-tooltip>

      <v-container fluid style="flex-grow: 1; display: flex; flex-direction: column" class="pa-3">
        <v-row style="flex-grow: 0">
          <v-col v-if="item.value.product" class="pb-0 pt-2">
            <v-icon color="error" class="mr-2" v-if="this.errors && this.errors.length > 0">mdi-alert</v-icon>
            <v-tooltip v-if="!showRoomCalendar && item.value.prev != undefined"
              :text="$t('messages.followUpFor', { date: item.value.prev.display_date })">
              <template v-slot:activator="{ props }">
                <v-icon :color="color" v-bind="props" class="mr-2">mdi-keyboard-tab-reverse</v-icon>
              </template>
            </v-tooltip>

            <b>{{ item.value.product.name }}</b>
            <span class="ml-2" v-if="duplicationMode">{{ item.value.display_date }}</span>
          </v-col>
          <v-col v-else-if="item.value.private" class="pb-0">
            <v-tooltip :text="$t('messages.googleImport')">
              <template v-slot:activator="{ props }">
                <v-icon v-bind="props" class="mr-2">mdi-google</v-icon>
              </template>
            </v-tooltip>
            <b>{{ item.value.description }}</b>
          </v-col>
          <v-col v-else class="pb-0">
            <b>{{ $t("basics.new", { type: $t("basics.appointment") }) }}</b>
          </v-col>
          <v-col v-if="!showRoomCalendar && !duplicationMode && item.value.public" cols="auto">
            <v-tooltip :text="$t('constants.product_status_public')">
              <template v-slot:activator="{ props }">
                <v-icon v-bind="props">mdi-eye</v-icon>
              </template>
            </v-tooltip>
          </v-col>
          <v-col v-if="duplicationMode" cols="auto">
            <v-icon>mdi-close</v-icon>
          </v-col>
        </v-row>

        <v-row v-if="!profileView && !showRoomCalendar && !duplicationMode && item.value.public && item.value.booking_counts"
          style="flex-grow: 0">
          <v-col cols="12" class="py-0">
            <small>Frei: {{ item.value.booking_counts.free }} · Bezahlt: {{ item.value.booking_counts.paid }} · Gesamt: {{ item.value.booking_counts.total }}</small>
          </v-col>
        </v-row>

        <v-row style="flex-grow: 0" v-if="item.value.teachers && item.value.teachers.length != 1">
          <v-col cols="12" class="py-0">
            <div v-for="(teacher, teacherIndex) in item.value.teachers" :key="teacher.id" density="compact"
              style="width: 100%">
              <span>{{ teacher.first_name?.substring(0, 1) }}
                {{ teacher.last_name.substring(0, 1) }}</span>
            </div>
          </v-col>
        </v-row>

        <v-row style="flex-grow: 1" v-if="!showRoomCalendar">
          <v-col class="py-0" cols="12" :style="{ color: roomConflict ? 'rgb(var(--v-theme-error))' : '' }">
            <div style="width: 100%" v-for="(room, roomIndex) in item.value.rooms" :key="room.id" density="compact">
              {{ room.name }}</div>
          </v-col>
        </v-row>

        <v-row style="flex-grow: 0" v-if="!showRoomCalendar && activePatients.length">
          <v-col class="pt-0" cols="12" style="display: flex">
            <v-icon class="mr-1" style="margin-top: 2px"
              v-if="this.activePatients.length == 1">mdi-account</v-icon>
            <v-icon class="mr-1" style="margin-top: 2px"
              v-else-if="this.activePatients.length > 1">mdi-account-multiple</v-icon>

            <div>
              <div style="width: 100%" v-for="(patient, patientIndex) in displayPatients" :key="patient.id"
                density="compact">
                {{ patient.user.full_name }}</div>
            </div>
            <div v-if="hiddenPatients" class="rounded-lg px-1 ml-1"
              style="background-color: rgba(var(--v-theme-primary), 0.2);">
              +{{ hiddenPatients }}
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-card flat
      style="overflow: auto; width: 100%; display: flex; flex-direction: column; justify-content: center; margin-top: 3px"
      class="noSelect px-2" :style="{
        height: heightPerSlot * (computedTravelTimeAfter) - 3 + 'px',
        'background-color': backgroundColor,
        color: color,
        'border': border,
        'pointer-events': item.value.created ? 'none' : 'all',
      }" v-if="!duplicationMode && item.rendered && computedTravelTimeAfter">
      <span v-if="!showRoomCalendar">
        <i v-if="isExternalLocation">{{ $t("basics.travelTimeAfter") }}</i>
        <i v-else>{{ $t("basics.prepTimeAfter") }}</i></span>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "timeTableCard",

  props: ["item", "heightPerSlot", "errors", "duplicationMode", "showRoomCalendar", "userColors", "profileView"],
  emits: ["acceptSuggestion", "denyTimeSlot"],

  data() {
    return {
      backgroundColors: [
        "var(--v-theme-light-yellow)",
        "var(--v-theme-light-blue)",
        "var(--v-theme-light-green)"
      ],
      colors: [
        "rgba(var(--v-theme-primary), 1)",
        "rgba(var(--v-theme-secondary), 1)",
        "rgba(var(--v-theme-success), 1)"
      ],
      borders: [
        "rgba(var(--v-theme-yellow), 1)",
        "rgba(var(--v-theme-blue), 1)",
        "rgba(var(--v-theme-green), 1)"
      ],
    }
  },


  computed: {
    activePatients() {
      return (this.item?.value?.patients || []).filter(patient => !patient.is_cancelled);
    },
    isExternalLocation() {
      return this.item.value.display_location == "external"
    },
    computedTravelTimePrev() {
      if (!this.item || !this.item.value || !this.item.value.travel_time_prev) {
        return 0
      }

      return this.item.value.travel_time_prev
    },
    computedTravelTimeAfter() {
      if (!this.item || !this.item.value || !this.item.value.travel_time_after) {
        return 0
      }

      return this.item.value.travel_time_after
    },
    displayPatients() {
      if (!this.item || !this.item.value || !this.item.value.patients) {
        return []
      }

      let result = []
      let count = this.maxDisplayPatients
      for (let i = 0; i < this.activePatients.length; i++) {
        if (count == 0) {
          break
        }

        result.push(this.activePatients[i])
        --count
      }
      return result
    },
    hiddenPatients() {
      if (!this.item || !this.item.value || !this.item.value.patients) {
        return []
      }

      if (this.activePatients.length > this.maxDisplayPatients) {
        return this.activePatients.length - this.maxDisplayPatients
      }

      return 0
    },
    maxDisplayPatients() {
      if (!this.item || !this.item.value || !this.item.value.time_units) {
        return 0
      }

      if (this.item.value.time_units.length <= 3) {
        return 1
      }

      if (this.item.value.time_units.length <= 6) {
        return 3
      }

      return 5
    },
    teacherConflict() {
      if (!this.item || !this.errors || this.errors.length == 0) {
        return false
      }

      for (let i = 0; i < this.errors.length; i++) {
        if (this.errors[i].teacher_conflict) {
          return true
        }
      }

      return false
    },
    roomConflict() {
      if (!this.item || !this.errors || this.errors.length == 0) {
        return false
      }

      for (let i = 0; i < this.errors.length; i++) {
        if (this.errors[i].room_conflict && this.errors[i].room_conflict.length > 0) {
          return true
        }
      }

      return false
    },
    vehicleConflict() {
      if (!this.item || !this.errors || this.errors.length == 0) {
        return false
      }

      for (let i = 0; i < this.errors.length; i++) {
        if (this.errors[i].vehicle_conflict) {
          return true
        }
      }

      return false
    },
    equipmentConflict() {
      if (!this.item || !this.errors || this.errors.length == 0) {
        return false
      }

      for (let i = 0; i < this.errors.length; i++) {
        if (this.errors[i].equipment_conflict) {
          return true
        }
      }

      return false
    },
    backgroundColor() {
      if (this.profileView) {
        return "rgba(var(--v-theme-light-blue), 1)";

      }

      if (this.showRoomCalendar && this.userColors) {
        let colors = new Set()
        if (this.item.value && this.item.value.teachers) {
          for (let i = 0; i < this.userColors.length; i++) {
            for (let j = 0; j < this.item.value.teachers.length; j++) {
              if (this.userColors[i].id == this.item.value.teachers[j].id) {
                colors.add(this.userColors[i].color_code)
              }
            }
          }
        }

        colors = Array.from(colors)
        if (colors.length == 1) {
          return colors[0]
        }
        else if (colors.length == 0) {
          return "rgba(var(--v-theme-error))"
        }
        else {
          //mix all colors
          const toRGB = (hex) => ({
            r: parseInt(hex.substr(1, 2), 16),
            g: parseInt(hex.substr(3, 2), 16),
            b: parseInt(hex.substr(5, 2), 16),
          });

          const toHex = (v) =>
            v.toString(16).padStart(2, '0');

          let r = 0, g = 0, b = 0;

          colors.forEach(hex => {
            const c = toRGB(hex);
            r += c.r;
            g += c.g;
            b += c.b;
          });

          const n = colors.length;

          r = Math.round(r / n);
          g = Math.round(g / n);
          b = Math.round(b / n);

          return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
        }
        // if (this.item.value.display_status != "planned") {
        //   return "rgba(var(--v-theme-background), 1)";
        // }

        // if (this.item.value.is_temporary) {
        //   return "rgba(var(--v-theme-background), 0.3)";
        // }

        // if (!this.item.value.accepted_by_patient) {
        //   return "rgba(" + this.backgroundColors[this.item.value.location] + ", 0.5)"
        // }

        // if (!this.item.value.accepted_by_therapist) {
        //   return "rgba(" + this.backgroundColors[this.item.value.location] + ", 0.5)"
        // }

        // if (this.item.value.location >= 0) {
        //   return "rgba(" + this.backgroundColors[this.item.value.location] + ", 1)"
        // }

      }
      else {
        if (this.item.value.display_status != "planned") {
          return "rgba(var(--v-theme-background), 1)";
        }

        if (this.item.value.is_temporary) {
          return "rgba(var(--v-theme-background), 0.3)";
        }

        if (!this.item.value.accepted_by_patient) {
          return "rgba(" + this.backgroundColors[this.item.value.location] + ", 0.5)"
        }

        if (!this.item.value.accepted_by_therapist) {
          return "rgba(" + this.backgroundColors[this.item.value.location] + ", 0.5)"
        }

        if (this.item.value.location >= 0) {
          return "rgba(" + this.backgroundColors[this.item.value.location] + ", 1)"
        }

      }

      return "rgba(var(--v-theme-background), 1)";

    },
    color() {
      if (this.showRoomCalendar && this.userColors && this.backgroundColor) {
        return this.getContrastColor(this.backgroundColor)
      }
      else {
        if (this.item.value.is_temporary || !this.item.value.id) {
          return "initial"
        }

        if (this.item.value.display_status != "planned") {
          return this.colors[this.item.value.location]
        }

        if (!this.item.value.accepted_by_patient) {
          return "initial";
        }
        if (!this.item.value.accepted_by_therapist) {
          return "initial";
        }

        if (this.item.value.location >= 0) {
          return this.colors[this.item.value.location]
        }
      }


      return "initial"
    },
    border() {
      if (this.errors && this.errors.length > 0) {
        return "3px solid rgba(var(--v-theme-error), 1)";
      }

      if (this.item.value.display_status != "planned") {
        return "3px solid " + this.borders[this.item.value.location]
      }

      return "none";
    },
  },

  methods: {
    getContrastColor(hexColor) {
      if (!hexColor || typeof hexColor != "string" || !hexColor.startsWith("#")) {
        return 'rgb(var(--v-theme-on-surface))'
      }

      // Hex → RGB
      const r = parseInt(hexColor.substr(1, 2), 16) / 255;
      const g = parseInt(hexColor.substr(3, 2), 16) / 255;
      const b = parseInt(hexColor.substr(5, 2), 16) / 255;

      // Gamma-Korrektur
      const toLinear = (c) => {
        return c <= 0.03928
          ? c / 12.92
          : Math.pow((c + 0.055) / 1.055, 2.4);
      };

      const R = toLinear(r);
      const G = toLinear(g);
      const B = toLinear(b);

      // Relative Luminanz
      const luminance = 0.2126 * R + 0.7152 * G + 0.0722 * B;

      // Du kannst hier mit echten Kontrastwerten rechnen,
      // aber für den praktischen Fall reicht ein Threshold:
      return luminance > 0.5
        ? 'rgb(var(--v-theme-on-surface))'   // dunklere Schrift
        : 'rgb(var(--v-theme-light))';       // hellere Schrift
    },
    handleAcceptSuggestion(event) {
      event.stopPropagation()
      event.preventDefault()
      
      this.$emit("acceptSuggestion")
    },
    handleDenyTimeSlot(event) {
      event.stopPropagation()
      event.preventDefault()

      this.$emit("denyTimeSlot")
    },
  },
};
</script>
